import $ from 'jquery';
import LP from '../0-lp';

// ================ //
// RANKING QUESTION //
// ================ //
LP.rankingQuestion = {
  dispatching: false,

  onLoad: function () {
    var tabname = LP.Dialog.getTabName();
    switch (tabname) {
      case 'advanced':
        LP.rankingQuestion.advTab.initEvents();
        break;
      case 'codes':
        LP.rankingQuestion.codeTab.initEvents();
        break;
    }
  },

  initNonAjaxTabs: function () {
    LP.rankingQuestion.answerTab.initEvents();
  },

  answerTab: {
    initEvents: function (root) {
      if (!root) root = $('#rankingGroups');

      $('a[action="addRankingGroup"]', root).click(function () {
        LP.dlgQuestion.addGroupHere($('#newGroup'), this.parentNode.parentNode, LP.rankingQuestion.answerTab.initEvents);
      });
      LP.UI.initButtonMenu({selector: $('.lp-menubar-rankinggroups', root), name: 'groupMenu'});
      $('a[action="editGroupname"]', root).click(function () {
        LP.dlgQuestion.editInput($('input[name="question[groupText][]"]', this.parentNode.parentNode), this);
      });
      $('a[action="deleteGroup"]', root).click(function () {
        LP.dlgQuestion.deleteGroup(this, LP.rankingQuestion.answerTab.checkOptions);
      });

      $('a[action="addOption"]', root).click(function () {
        LP.dlgQuestion.addOptionHere($('#newGroup'), this.parentNode, LP.rankingQuestion.answerTab.initEvents);
      });
      LP.UI.initButtonMenu({selector: $('.lp-menubar-rankingoptions', root), name: 'optionMenu'});
      $('a[action="editInput"]', root).click(function () {
        LP.dlgQuestion.editInput($('input[name="question[texts][]"]', this.parentNode), this);
      });
      $('a[action="deleteOption"]', root).click(function () {
        LP.dlgQuestion.deleteOption(this, LP.rankingQuestion.answerTab.checkOptions);
      });

      $('a[action="toggleInputType"]', root).click(LP.dlgQuestion.toggleInputType);
      $('a[action="toggleFixPos"]', root).click(LP.dlgQuestion.toggleFixPos);

      LP.rankingQuestion.answerTab.checkOptions();
    },

    checkOptions: function () {
      if (LP.rankingQuestion.dispatching) return;
      else LP.rankingQuestion.dispatching = true;
      var groups = $('#rankingGroups');
      if ($('fieldset', groups).length == 0) LP.dlgQuestion.addGroup($('#newGroup'), groups, LP.rankingQuestion.answerTab.initEvents);
      groups.children().each(function (index, group) {
        if ($('li', group).length == 0) {
          LP.dlgQuestion.addOption($('#newGroup'), $('ul', group), LP.rankingQuestion.answerTab.initEvents);
        }
      });
      LP.dlgQuestion.setPositions('.groupnum');
      LP.rankingQuestion.dispatching = false;
    },
  },

  advTab: {
    initEvents: function () {
      LP.dlgQuestion.initDefaultTextInputs();
    },
  },

  codeTab: {
    initEvents: function (root) {
      if (!root) root = $('body');
      $('input#lp-auto-codes', root).change(LP.dlgQuestion.checkAutoCodes);
      LP.dlgQuestion.checkAutoCodes();

      $('#questionVarname', root).keyup(function () {
        $('td.varnameCol').html($('#questionVarname').attr('value'));
      });

      LP.rankingQuestion.codeTab.setNumbers();
    },

    setNumbers: function () {
      $('.codeGroupNum').each(function (index, element) {
        $(element).html(index + 1);
      });
    },
  },
};
